







import AbstractColumnLink from '@/abstract/ColumnLink'
import AbstractColumnValue from '@/abstract/ColumnValue'
import mixins from 'vue-typed-mixins'
import ScriptStatusIcon from '@/components/Scripts/ScriptStatusIcon.vue'

export default mixins(AbstractColumnLink, AbstractColumnValue).extend({
  components: {
    ScriptStatusIcon,
  },
})
